import React from 'react';
import { View } from 'react-native';

import { StyleObj } from '@providers/Theme/types';
import { makeStyles } from '@providers/Theme';

type ScreenContentProps = {
  children: React.ReactNode;
  style?: StyleObj;
};

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '100%',
    backgroundColor: 'white',
    overflowX: 'auto',
    overflowY: 'auto',
  },
}));

export const ScreenContent: React.FC<ScreenContentProps> = ({
  children,
  style,
}) => {
  const styles = useStyles();

  return <View style={[styles.root, style]}>{children}</View>;
};
